import { useParams } from 'react-router-dom';
import Panel from '../../../common/layout/Panel'
import DataResource from '../../../common/v4/DataResource';

const CarrierAccountBilling = () => {
    const { carrier_id } = useParams();
    const data = {
        url: `/admin/carriers/carriers/${carrier_id}/billing`,
        data: {
            data: [],
            metadata: []
        },
        userFilterExpandable: false,
        metadata: [
            {
                source: 'id',
                label: 'ID',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                source: 'type',
                label: 'Type',
                type: 'select',
            },
            {
                source: 'date',
                label: 'Date',
                type: 'date',
            },
            {
                source: 'reference',
                label: 'Reference',
                type: 'text',
            },
            {
                source: 'description',
                label: 'Description',
                type: 'text',
            },
            {
                source: 'amount',
                label: 'Amount',
                type: 'text',
            },
            {
                source: 'currency_id',
                label: 'Currency',
                type: 'select',
            },
            {
                source: 'pdf_link',
                label: 'PDF',
                type: 'text',
            },
            {
                type: 'delete',
                label: 'Delete',
            }
        ]
    }
    return (
       <Panel title = "Billing - Payments & Invoices">
            <DataResource
                addButtonText = "Create Payment"
                addButtonLink = {`/carriers/carriers/${carrier_id}/billing/create`}                    
                data = {data}
            />
        </Panel>
    )
}

export default CarrierAccountBilling;
